// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromStringInsuranceAwardType(award_type) {
  switch (award_type) {
    case "discount" :
        return /* Discount */1;
    case "price" :
        return /* Price */0;
    default:
      return ErrorUtils$Catalyst.raiseError("Award.re", "insurance award benefit type not found", award_type);
  }
}

function toString(award) {
  if (typeof award === "number") {
    return "DefaultAward";
  }
  switch (award.TAG | 0) {
    case /* Fuel */0 :
        return "Fuel";
    case /* Premiumness */1 :
        return "Premiumness";
    case /* RewardMultiplier */2 :
        return "RewardMultiplier";
    case /* NoAward */3 :
        return "NoAward";
    case /* Monetary */4 :
        return "Monetary";
    case /* Insurance */5 :
        return "Insurance";
    case /* DistributionCeremony */6 :
        return "DistributionCeremony";
    case /* Final */7 :
        return "Final";
    case /* Coupon */8 :
        return "Coupon";
    
  }
}

export {
  fromStringInsuranceAwardType ,
  toString ,
  
}
/* No side effect */
